import { LabelHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

const labelVariants = {
  default: "text-[11px] font-bold text-[#6A7282] uppercase tracking-wide",
} as const;

type LabelVariant = keyof typeof labelVariants;

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  variant?: LabelVariant;
  optional?: boolean;
}

export function Label({
  variant = "default",
  optional,
  className,
  children,
  ...props
}: LabelProps) {
  return (
    <label className={twMerge(labelVariants[variant], className)} {...props}>
      {children}
      {optional && (
        <span className="ml-1 font-medium tracking-normal normal-case">
          (optional)
        </span>
      )}
    </label>
  );
}
